import { useEffect, useState } from "react";

const QUERY = "(min-width: 1024px)";

/** true no desktop (≥ 1024px, breakpoint `lg`) — renderiza tabela OU cards, nunca os dois no DOM. */
export const useIsDesktop = () => {
  const [desktop, setDesktop] = useState(() => (typeof window !== "undefined" ? window.matchMedia(QUERY).matches : true));
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setDesktop(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return desktop;
};

/** Valor com atraso (debounce) — a busca só dispara ~400 ms depois da última tecla. */
export const useDebouncedValue = (value, delay = 400) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};
